import { useTranslation } from '@crehana/i18n';

import { LogoLight } from './Logos';

const PoweredBy = () => {
  const { t } = useTranslation();

  return (
    <div className="cui-container tw-flex tw-items-center tw-py-1.6 tw-mb-4">
      <span className="tw-font-body5 tw-text-neutral-light-500 tw-mr-0.4">
        {t('POWERED_BY')}
      </span>
      <div className="tw-ml-0.2">
        <LogoLight />
      </div>
    </div>
  );
};

export default PoweredBy;
